export enum SelectVariant {
  Text = 'Text',
  Default = 'Default',
  DropDown = 'DropDown',
}
